import { render, staticRenderFns } from "./Detalhapedido.vue?vue&type=template&id=906e7f26"
import script from "./Detalhapedido.vue?vue&type=script&lang=js"
export * from "./Detalhapedido.vue?vue&type=script&lang=js"
import style0 from "./Detalhapedido.vue?vue&type=style&index=0&id=906e7f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports